import { SyntheticEvent } from 'react'

import { FormControl } from '@mui/material'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@collaborate-health/uikit'

export interface ExportAsPdfOptionsDialogProps {
  isExportPdfOptionsDialogOpen: boolean
  closeDialog: () => void
  next: () => void
  isShowProgress: boolean
  setPdfExportOption: (e: SyntheticEvent<Element, Event>, value: number) => void
  selectedOption: number
  exportOptions: Array<{ Id: number; Value: string }>
}

const ExportAsPdfOptionsDialog: React.FC<ExportAsPdfOptionsDialogProps> = ({
  isExportPdfOptionsDialogOpen,
  closeDialog,
  next,
  isShowProgress,
  setPdfExportOption,
  selectedOption,
  exportOptions,
}) => {
  return (
    <Dialog open={isExportPdfOptionsDialogOpen} maxWidth='xs' fullWidth onClose={closeDialog}>
      <DialogTitle>Export session media in the order of</DialogTitle>
      <DialogContent>
        <FormControl>
          <RadioGroup value={selectedOption}>
            {exportOptions.map((option) => (
              <FormControlLabel
                key={option.Id}
                value={option.Id}
                control={<Radio />}
                label={option.Value}
                onChange={(e) => setPdfExportOption(e, option.Id)}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button color='primary' onClick={closeDialog}>
          Close
        </Button>
        <Button color='primary' loading={isShowProgress} variant='contained' onClick={next}>
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ExportAsPdfOptionsDialog

